import { useEffect, useRef } from "react"
import { signOut } from "firebase/auth"
import { auth } from "../config"
import { resetUserData } from "../States/userDataSlice"
import { useDispatch } from "react-redux"
import { resetSteps } from "../States/educatorStepsSlice"
import { resetCoursesSteps } from "../States/coursesStepsSlice"

const useMonitorEmailVerify = (userData) => {
  const dispatch = useDispatch()
  const previousEmailVerifyRef = useRef(userData?.email_verified)

  useEffect(() => {
    if (!userData) {
      previousEmailVerifyRef.current = undefined;
      return;
    }
    const previousEmailVerify = previousEmailVerifyRef.current
    if (previousEmailVerify === true && userData?.email_verified === false) {
      signOut(auth).then(() => {
        dispatch(resetSteps())
        dispatch(resetCoursesSteps());
        dispatch(resetUserData())
        window.location.reload()
      })
    }
    
    previousEmailVerifyRef.current = userData?.email_verified
  }, [userData?.email_verified, userData, dispatch])
}
export default useMonitorEmailVerify
